var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 4,
    width: "800px",
    height: "800px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Review Icon - Dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Review"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5,36h-5a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-19A.5.5,0,0,0,39.5,36ZM39,55H35V37h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,36h-12l1.16-5.81a3.48,3.48,0,0,0-1.77-3.76l-.68-.37a.51.51,0,0,0-.68.2l-5.5,10a.5.5,0,0,0-.06.24v17A2.5,2.5,0,0,0,45.5,56H57.79a6.48,6.48,0,0,0,5.83-3.62L67,44.7a.45.45,0,0,0,0-.2v-4A4.51,4.51,0,0,0,62.5,36ZM66,44.4,62.71,52a5.48,5.48,0,0,1-4.92,3H45.5A1.5,1.5,0,0,1,44,53.5V36.63l5.2-9.45.24.13A2.5,2.5,0,0,1,50.71,30l-1.28,6.4a.53.53,0,0,0,.1.42.53.53,0,0,0,.39.18H62.5A3.5,3.5,0,0,1,66,40.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.54,20H26.46A10.47,10.47,0,0,0,16,30.46V54.54A10.47,10.47,0,0,0,26.46,65h11.8l9.35,11.81a.5.5,0,0,0,.78,0L57.74,65h11.8A10.47,10.47,0,0,0,80,54.54V30.46A10.47,10.47,0,0,0,69.54,20ZM79,54.54A9.48,9.48,0,0,1,69.54,64h-12a.49.49,0,0,0-.39.19L48,75.69l-9.11-11.5A.49.49,0,0,0,38.5,64h-12A9.48,9.48,0,0,1,17,54.54V30.46A9.48,9.48,0,0,1,26.46,21H69.54A9.48,9.48,0,0,1,79,30.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedBack);
export default __webpack_public_path__ + "static/media/feedBack.abaf66a52a1b3c5ba1e6e9b674dcc8ab.svg";
export { ForwardRef as ReactComponent };